export function getNestedSlices(node: any): any[] {
    if (!node || !node.data) return [];
    // TODO: this is more complicated than it should be.
    // make s-all-products use the same format as wrapper, tabs, side-menu
    const nested = node.name === 's-all-products'
        ? (node.data.slicesData || []).flatMap((x: any) => x?.slices || [])
        : (node.data.slices || []);

    return Array.isArray(nested) ? nested.filter(Boolean) : [];
}
